import { memo, useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { defaultMentalStateData } from '../../../utils/helpers';

const MentalStateExamination = ({
    selectedOnExamination,
    handleOnExaminationData,
}) => {
    let { mentalStateExamination } = selectedOnExamination;
    mentalStateExamination = mentalStateExamination || defaultMentalStateData();

    const handleMentalStateExamination = (field, value) => {
        const updatedData = { ...mentalStateExamination };
        updatedData[field] = value;

        handleOnExaminationData(updatedData, 'mentalStateExamination');
    };

    return (
        <div className="general-examination">
            <Form.Group as={Row} className="mb-3">
                <Col sm="3">
                    <Form.Label column className="font-weight-bold">
                        Appearance and Behavior:
                    </Form.Label>
                </Col>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        placeholder="Note"
                        value={mentalStateExamination.appearanceAndBehavior || ''}
                        onChange={(e) =>
                            handleMentalStateExamination('appearanceAndBehavior', e.target.value)
                        }
                        size="sm"
                    />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
                <Col sm="3">
                    <Form.Label column className="font-weight-bold">
                        Speech:
                    </Form.Label>
                </Col>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        placeholder="Note"
                        value={mentalStateExamination.speech || ''}
                        onChange={(e) =>
                            handleMentalStateExamination('speech', e.target.value)
                        }
                        size="sm"
                    />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
                <Col sm="3">
                    <Form.Label column className="font-weight-bold">
                        Mood and Affect:
                    </Form.Label>
                </Col>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        placeholder="Note"
                        value={mentalStateExamination.moodAndAffect || ''}
                        onChange={(e) =>
                            handleMentalStateExamination('moodAndAffect', e.target.value)
                        }
                        size="sm"
                    />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
                <Col sm="3">
                    <Form.Label column className="font-weight-bold">
                        Perception:
                    </Form.Label>
                </Col>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        placeholder="Note"
                        value={mentalStateExamination.perception || ''}
                        onChange={(e) =>
                            handleMentalStateExamination('perception', e.target.value)
                        }
                        size="sm"
                    />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
                <Col sm="3">
                    <Form.Label column className="font-weight-bold">
                        Thought Process:
                    </Form.Label>
                </Col>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        placeholder="Note"
                        value={mentalStateExamination.thoughtProcess || ''}
                        onChange={(e) =>
                            handleMentalStateExamination('thoughtProcess', e.target.value)
                        }
                        size="sm"
                    />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
                <Col sm="3">
                    <Form.Label column className="font-weight-bold">
                        Thought Content:
                    </Form.Label>
                </Col>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        placeholder="Note"
                        value={mentalStateExamination.thoughtContent || ''}
                        onChange={(e) =>
                            handleMentalStateExamination('thoughtContent', e.target.value)
                        }
                        size="sm"
                    />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
                <Col sm="3">
                    <Form.Label column className="font-weight-bold">
                        Insight:
                    </Form.Label>
                </Col>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        placeholder="Note"
                        value={mentalStateExamination.insight || ''}
                        onChange={(e) =>
                            handleMentalStateExamination('insight', e.target.value)
                        }
                        size="sm"
                    />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
                <Col sm="3">
                    <Form.Label column className="font-weight-bold">
                        Judgment:
                    </Form.Label>
                </Col>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        placeholder="Note"
                        value={mentalStateExamination.judgment || ''}
                        onChange={(e) =>
                            handleMentalStateExamination('judgment', e.target.value)
                        }
                        size="sm"
                    />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
                <Col sm="3">
                    <Form.Label column className="font-weight-bold">
                        Cognition:
                    </Form.Label>
                </Col>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        placeholder="Note"
                        value={mentalStateExamination.cognition || ''}
                        onChange={(e) =>
                            handleMentalStateExamination('cognition', e.target.value)
                        }
                        size="sm"
                    />
                </Col>
            </Form.Group>
        </div>
    );
};

export default memo(MentalStateExamination);